import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG_TOKEN } from '@quipex/core/config';
import type { HttpClientOptions } from '@quipex/core/primitives';

@Injectable({
    providedIn: 'root',
})
export class AzureFunctionApiService {
    // --- Dependency injection ---
    private readonly http = inject(HttpClient);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    // --- Constants ---
    private readonly apiUrl = `${this.appConfig.apiFunctionBase}/api`;

    // --- Public methods ---

    runSearchIndexer(options?: HttpClientOptions) {
        const url = `${this.apiUrl}/RunIndexer`;
        return this.http.get<unknown>(url, options);
    }
}
